import React, { useState } from "react";
import {
  Paper,
  IconButton,
  Modal,
  Box,
  Button,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import "react-quill/dist/quill.snow.css";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ReactQuill from "react-quill";

const colorOptions = [
  "#f6e1ff",
  "#fff9c4",
  "#c8e6c9",
  "#b3e5fc",
  "#ffe0b2",
  "#ffcdd2",
  "#e1bee7",
];

const CONTENT_CHAR_LIMIT = 200;

function stripHtml(html) {
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

function NotePadrao({ isDarkMode }) {
  const [hovered, setHovered] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("");
  const [color, setColor] = useState("#009373");
  const [deleteNoteDialogOpen, setDeleteNoteDialogOpen] = useState(false);
  const [alert2, setAlert2] = React.useState(null);
  const isDark = !!isDarkMode;
  const modalBg = isDark ? "#2a2a2a" : "#fff";
  const modalText = isDark ? "#fff" : "#172B4D";
  const modalBorder = isDark ? "#444" : "#eee";
  const modalShadow = isDark
    ? "0 2px 24px rgba(0,0,0,0.85)"
    : "0 2px 24px rgba(0,0,0,0.08)";
  const modalHeaderBg = modalBg;

  // Define a cor da dobra da nota SEM transparência, sempre igual à cor da lista
  const foldColor = isDark ? "#2a2a2a" : "#d9d9d9";

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleOpenModal = (e) => {
    e.stopPropagation();
    setModalOpen(true);
  };

  const handleOpenDeleteNoteDialog = () => {
    setDeleteNoteDialogOpen(true);
  };

  const handleCloseDeleteNoteDialog = () => {
    setDeleteNoteDialogOpen(false);
  };

  return (
    <div
      style={{ marginBottom: 10, position: "relative" }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div
        style={{
          backgroundColor: "#c8e6c9",
          borderRadius: "12px 16px 12px 12px",
          padding: "16px",
          marginBottom: "12px",
          position: "relative",
          color: "#000",
          boxShadow: "none",
          fontFamily: "sans-serif",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            width: 32,
            height: 32,
            background: "#c8e6c9",
            borderTopRightRadius: "16px",
            zIndex: 1,
            pointerEvents: "none",
          }}
        />
        <div
          className="note-fold"
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            width: 0,
            height: 0,
            borderLeft: "30px solid transparent",
            borderTop: `30px solid ${foldColor}`,
            borderTopRightRadius: "12px",
            zIndex: 2,
            boxShadow: "-6px 6px 8px -4px rgba(0,0,0,0.18)",
            pointerEvents: "none",
          }}
        />

        <IconButton
          size="small"
          onClick={handleOpenModal}
          style={{
            position: "absolute",
            bottom: 4,
            right: 36,
            zIndex: 3,
            background: "transparent",
            color: "#009373",
          }}
          disableRipple
          disableFocusRipple
        >
          <EditIcon fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          style={{
            position: "absolute",
            bottom: 4,
            right: 4,
            zIndex: 3,
            background: "transparent",
            color: "#b52626",
          }}
          disableRipple
          disableFocusRipple
        >
          <DeleteRoundedIcon fontSize="small" />
        </IconButton>
        <div>
          <div
            style={{
              fontWeight: 600,
              fontSize: 14,
              marginBottom: 4,
              wordBreak: "break-word",
              whiteSpace: "pre-line",
              overflowWrap: "break-word",
              maxWidth: "100%",
            }}
          >
            {"Titulo da nota"}
          </div>
          <div
            style={{
              fontSize: 14,
              fontStyle: "italic",
              wordBreak: "break-word",
            }}
            // dangerouslySetInnerHTML={{ __html: note.content }}
          />
        </div>
      </div>

      {/* Modal */}
      <Modal
        open={modalOpen}
        onClose={handleCloseModal}
        aria-labelledby="modal-editar-nota"
        aria-describedby="modal-editar-nota-desc"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1300,
        }}
      >
        <Box
          sx={{
            bgcolor: modalBg,
            color: modalText,
            borderRadius: "8px",
            boxShadow: modalShadow,
            p: 0,
            width: "100%",
            maxWidth: 420,
            minWidth: 320,
            minHeight: 340,
            outline: "none",
            position: "relative",
            overflow: "hidden",
            border: `1px solid ${modalBorder}`,
            transition: "background 0.2s, color 0.2s",
            mx: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 3,
              py: 2,
              borderBottom: `1px solid ${modalBorder}`,
              background: modalHeaderBg,
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              transition: "background 0.2s",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Editar Nota
            </Typography>
            <IconButton
              onClick={handleCloseModal}
              size="small"
              sx={{ background: "transparent" }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              p: 3,
              display: "flex",
              flexDirection: "column",
              gap: 2,
              background: modalBg,
              color: modalText,
              minHeight: 220,
              transition: "background 0.2s, color 0.2s",
              width: "100%",
              maxWidth: 380,
              mx: "auto",
            }}
          >
            <label
              style={{
                fontSize: 15,
                fontWeight: 600,
                marginBottom: 4,
                color: modalText,
                letterSpacing: 0.2,
              }}
            >
              Título
            </label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value.slice(0, 20))}
              maxLength={20}
              style={{
                width: "100%",
                maxWidth: "100%",
                padding: "10px 12px",
                borderRadius: 6,
                border: `1.5px solid ${isDark ? "#555" : "#ccc"}`,
                background: isDark ? "#333" : "#fff",
                color: modalText,
                fontSize: 15,
                marginBottom: 4,
                outline: "none",
                transition: "border-color 0.2s",
                boxSizing: "border-box",
                display: "block",
              }}
              onFocus={(e) => (e.target.style.borderColor = "#009373")}
              onBlur={(e) =>
                (e.target.style.borderColor = isDark ? "#555" : "#ccc")
              }
              placeholder="Digite o título da nota"
            />
            <div
              style={{
                textAlign: "right",
                fontSize: 12,
                color: title.length >= 20 ? "#ff6961" : modalText,
                marginTop: 2,
                marginBottom: 12,
              }}
            >
              {title.length}/20
            </div>
            <label
              style={{
                fontSize: 15,
                fontWeight: 600,
                marginBottom: 4,
                color: modalText,
                letterSpacing: 0.2,
              }}
            >
              Conteúdo
            </label>
            <div style={{ marginBottom: 8 }}>
              <ReactQuill
                value={content}
                modules={{
                  toolbar: [
                    ["bold", "italic", "underline", "strike"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["link"],
                    ["clean"],
                  ],
                }}
                formats={[
                  "bold",
                  "italic",
                  "underline",
                  "strike",
                  "list",
                  "bullet",
                  "link",
                ]}
                style={{
                  background: isDark ? "#333" : "#fff",
                  color: modalText,
                  borderRadius: 6,
                  minHeight: 80,
                  maxHeight: 120,
                  marginBottom: 0,
                  overflowY: "auto",
                }}
                theme="snow"
                onKeyDown={(e) => {
                  const plain = stripHtml(content);
                  // Permite teclas de navegação, delete, backspace, etc
                  if (
                    plain.length >= CONTENT_CHAR_LIMIT &&
                    e.key.length === 1 && // só bloqueia caracteres imprimíveis
                    !e.ctrlKey &&
                    !e.metaKey &&
                    !e.altKey
                  ) {
                    e.preventDefault();
                  }
                }}
              />
              <div
                style={{
                  textAlign: "right",
                  fontSize: 12,
                  color:
                    stripHtml(content).length >= CONTENT_CHAR_LIMIT
                      ? "#ff6961"
                      : modalText,
                  marginTop: 2,
                  marginBottom: 12,
                }}
              >
                {stripHtml(content).length}/{CONTENT_CHAR_LIMIT}
              </div>
            </div>
            <div style={{ marginBottom: 8 }}>
              <span style={{ fontSize: 14, color: modalText }}>Cor:</span>
              <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                {colorOptions.map((opt) => (
                  <div
                    key={opt}
                    onClick={() => setColor(opt)}
                    style={{
                      width: 28,
                      height: 28,
                      borderRadius: "50%",
                      background: opt,
                      border:
                        color === opt ? "2px solid #4b2e83" : "2px solid #fff",
                      cursor: "pointer",
                      boxShadow: color === opt ? "0 0 4px #4b2e83" : undefined,
                      outline:
                        isDark && color === opt ? "1px solid #fff" : undefined,
                    }}
                  />
                ))}
              </div>
            </div>
            <Button
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              fullWidth
              sx={{
                mt: 2,
                fontWeight: 600,
                borderRadius: 2,
                background: "#009373",
                color: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                "&:hover": {
                  background: "#009373",
                  opacity: 0.9,
                },
              }}
              disabled={stripHtml(content).length > CONTENT_CHAR_LIMIT}
            >
              Salvar
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export default NotePadrao;
